import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// When a master admin previews a client portal, all requests carry the
// impersonation token (Bearer takes precedence over the admin cookie server-side).
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("impersonation_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Broadcast every successful save so open pages (this tab + other tabs) re-fetch.
const bc = typeof BroadcastChannel !== "undefined" ? new BroadcastChannel("pw-saved") : null;
export const SAVED_EVENT = "pw:saved";
api.interceptors.response.use((res) => {
  const m = (res.config?.method || "get").toLowerCase();
  if (m !== "get" && m !== "head" && m !== "options") {
    window.dispatchEvent(new CustomEvent(SAVED_EVENT, { detail: { url: res.config?.url, method: m } }));
    bc?.postMessage({ url: res.config?.url, method: m });
  }
  return res;
});
if (bc) bc.onmessage = (ev) => window.dispatchEvent(new CustomEvent(SAVED_EVENT, { detail: { ...ev.data, remote: true } }));

export function apiErr(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((x) => (x?.msg ? x.msg : JSON.stringify(x))).join(" ");
  if (d?.message) return d.message;
  if (d?.msg) return d.msg;
  return String(d);
}

export const pdfUrl = (path) => `${API_BASE}${path}`;
